import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { appRouterPaths } from "@/services/navigation";
import { useInitRecoveryMutation } from "@/services/api";
import { getPhoneNumberSchema } from "@/entities/phone-number-form";
import { useAppDispatch } from "@/services/store";
import type { PhoneNumberFormValues } from "@/entities/phone-number-form";
import { passwordRecoveryActions, startCoolDownTimer } from "../password-recovery-slice";
import { RESEND_COOL_DOWN } from "../constants";
import { PasswordRecoverySteps } from "../types";

export const usePhoneNumberForm = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [init, { isLoading }] = useInitRecoveryMutation();

  const formApi = useForm({
    resolver: yupResolver(getPhoneNumberSchema()),
  });

  const handleSubmit = (data: PhoneNumberFormValues) => {
    init(data)
      .unwrap()
      .then(() => {
        dispatch(startCoolDownTimer(RESEND_COOL_DOWN));
        dispatch(passwordRecoveryActions.setMobilePhone(data.mobilePhone));
        dispatch(passwordRecoveryActions.setStep(PasswordRecoverySteps.SMS_CODE_STEP));
      })
      .catch((error) => {
        formApi.setError("root.mobilePhoneError", { message: error.message });
        formApi.setError("mobilePhone", {});
      });
  };

  const handleCancel = () => {
    navigate(appRouterPaths.logIn);
  };

  const submitDisabled = !formApi.formState.isValid;

  return {
    formApi,
    handleSubmit,
    handleCancel,
    submitDisabled,
    isLoading,
  };
};
